import React from "react";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { LOADING_EMUNS } from "../constant";

const UploadSpreadSheetLoadingInfo = () => {
  const {
    totalSuccessCardsCount,
    totalUploadedCardsCount,
    totalErrorCardsCount,
  } = useSelector((state) => state.ssUploader.cards);
  const loadingState = useSelector((state) => state.ssUploader.loading.state);
  const percentComplete = (
    (totalSuccessCardsCount / totalUploadedCardsCount) *
    100
  ).toString();

  const Wrapper = styled.div`
    font-size: 18px;
    text-align: center;
    margin: 40px 0 0 0;
    color: #999999;
  `;
  const ErrorSpan = styled.span`
    color: red;
  `;
  const ProgressBar = styled.progress`
    width: 100%;
  `;

  if (loadingState === LOADING_EMUNS.LOADING) {
    return (
      <>
        <Wrapper>
          <div>
            There were
            <ErrorSpan>
              {" "}
              {totalErrorCardsCount} errors out of {totalUploadedCardsCount}{" "}
            </ErrorSpan>
            found during processing.
          </div>
        </Wrapper>
        <ProgressBar max="100" value={percentComplete}>
          {percentComplete}
          &#37;
        </ProgressBar>
      </>
    );
  }

  return null;
};

export { UploadSpreadSheetLoadingInfo };
